import { render } from "./ui-table-header-item.vue?vue&type=template&id=7190a202&ts=true"
import script from "./ui-table-header-item.vue?vue&type=script&lang=ts"
export * from "./ui-table-header-item.vue?vue&type=script&lang=ts"

import "./ui-table-header-item.vue?vue&type=style&index=0&id=7190a202&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__